var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIncuietoareAntiefractieWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eedacb9c-47d9-46c7-bb87-c78f4e9a9878",
    "data-name": "incuietoare_antiefractie",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150.51 198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b3d74794-a3ac-4456-993d-2997e20496b4,.fe1dae75-22b0-4a4d-8597-de123ac249dc{fill:none;}.b3d74794-a3ac-4456-993d-2997e20496b4,.b60306ab-63ec-4762-9a93-d54289172394,.fe1dae75-22b0-4a4d-8597-de123ac249dc{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.b3d74794-a3ac-4456-993d-2997e20496b4,.b60306ab-63ec-4762-9a93-d54289172394{stroke-width:5px;}.b60306ab-63ec-4762-9a93-d54289172394{fill:#fff;}.fe1dae75-22b0-4a4d-8597-de123ac249dc{stroke-width:8px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "incuietoare_antiefractie_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f6f0b1a4-4944-494d-8f48-e0c20ec5f2d1",
    "data-name": "Shield copy 3"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "b3d74794-a3ac-4456-993d-2997e20496b4",
    points: "6.08 30.49 82.23 30.71 116.75 37.77 140.45 60.29 148.01 94.9 139.77 122.41 112.27 132.04 92.6 124.1 87.65 109.91 95.56 97.85 110.8 97.89 112.68 81.88 96.96 67.91 79.89 68.65 62.15 72.93 24.07 72.82"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b60306ab-63ec-4762-9a93-d54289172394",
    cx: 99,
    cy: 86,
    r: 5
  }), /*#__PURE__*/React.createElement("line", {
    className: "fe1dae75-22b0-4a4d-8597-de123ac249dc",
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 194
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncuietoareAntiefractieWhite);
export default __webpack_public_path__ + "static/media/incuietoare_antiefractie_white.6688f644401d11f488b36e69879ec875.svg";
export { ForwardRef as ReactComponent };